import React, { useMemo } from "react";
import createDOMPurify from "dompurify";

import { FormFieldWrapperProps } from "./types";
import BaseError from "../FormFields/BaseError";

import "./styles.css";

const DOMPurify = createDOMPurify(window);

const FormFieldWrapper = ({
  label,
  description,
  helpText,
  error,
  children,
  required,
}: FormFieldWrapperProps) => {
  const sanitizedHelpText = useMemo(() => {
    if (!helpText) return "";
    return DOMPurify.sanitize(helpText, {
      USE_PROFILES: { html: true },
    });
  }, [helpText]);

  return (
    <div className="flex flex-col gap-100 full-width">
      <div>
        <div className="flex flex-wrap items-center gap-100 full-width">
          <h6 className="body-s-medium">
            {label}
            {required && " *"}
          </h6>
          <p
            className="form-field-wrapper-help-text body-s-regular"
            dangerouslySetInnerHTML={{
              __html: sanitizedHelpText,
            }}
          ></p>
        </div>
        <i className="body-s-regular">{description}</i>
      </div>

      {children}
      <BaseError error={error} />
    </div>
  );
};

export default React.memo(FormFieldWrapper);
